/**
 * Page titles and footer labels in title case (the Oct 21 canvas: "Pull & Pack
 * List", "Prep Recipes", "Mac + Broccoli Combo"). A word the source already
 * capitalizes inside ("BBQ", "WGR", "PM", "McDonald") or that carries a digit
 * ("1%", "6oz") keeps its letters; short joining words stay lower case past
 * the first word. Pure; unit-tested.
 */

const SMALL_WORDS = new Set([
  'a',
  'an',
  'and',
  'as',
  'at',
  'by',
  'for',
  'in',
  'la',
  'of',
  'on',
  'or',
  'the',
  'to',
  'w/',
  'with',
])

function capitalize(word: string): string {
  if (/\d/.test(word) || /[A-Z]/.test(word.slice(1))) {
    return word
  }
  return word.replace(/^([^\p{L}]*)(\p{L})/u, (_, lead: string, letter: string) => lead + letter.toUpperCase())
}

/** "pull & pack list" → "Pull & Pack List"; "steamed broccoli · à la carte" → "Steamed Broccoli · À la Carte". */
export function titleCase(text: string): string {
  let first = true
  return text
    .split(/(\s+)/)
    .map((part) => {
      if (/^\s+$/.test(part) || part === '') {
        return part
      }
      // A separator ("·", "+", "&", "–") starts the next phrase, whose first word is capitalized.
      if (!/\p{L}/u.test(part)) {
        first = part === '·' || part === '–' || part === ':' ? true : first
        return part
      }
      const lower = part.toLowerCase()
      const word = !first && SMALL_WORDS.has(lower) ? (/[A-Z]/.test(part.slice(1)) ? part : lower) : capitalize(part)
      first = false
      return word
    })
    .join('')
}
